
import { Module } from '../core';

export default class ModulePrint extends Module {

    constructor() {
        super('print');
    }
}
